// extracted by mini-css-extract-plugin
export default {"mochi-pay-setting":"setting_mochi-pay-setting__G1InV","body":"setting_body__lw441","title":"setting_title__ygfex"};